import React from 'react';
import PropTypes from 'prop-types';
import { MuiPickersUtilsProvider, DatePicker, DateTimePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { InputBase, TextField, MuiThemeProvider } from '@material-ui/core';
import defaultMuiTheme from '../../../styles/Default';

/* eslint-disable react/jsx-props-no-spreading */
const TextFieldComponent = (props) => <InputBase {...props} />;

const Picker = (props) => {
  // Props
  const {
    label, value, action, format,
    variant, fullWidth,
    dateTime, helperText, error, placeholder,
    fieldType, disabled, required,
  } = props;

  const DateTextFieldComponent = (textFieldProps) => (
    <TextField
      {...textFieldProps}
      variant={variant || 'outlined'}
      placeholder={placeholder || ''}
      error={error}
      helperText={helperText}
      required={required}
    />
  );
  let textField;
  if (fieldType) {
    textField = DateTextFieldComponent;
  } else {
    textField = TextFieldComponent;
  }
  let content;
  if (dateTime) {
    content = (
      <DateTimePicker
        TextFieldComponent={textField}
        value={value}
        label={label || ''}
        variant="inline"
        inputVariant={variant || 'outlined'}
        format={format || 'YYYY-MM-DD'}
        disablePast
        fullWidth={fullWidth || false}
        onChange={action}
        showTodayButton
        ampm={false}
        disabled={disabled}
        required={required}
      />
    );
  } else {
    content = (
      <MuiThemeProvider theme={defaultMuiTheme}>
        <DatePicker
          TextFieldComponent={textField}
          value={value}
          label={label || ''}
          onChange={action}
          format={format || 'YYYY-MM-DD'}
          fullWidth={fullWidth || false}
          placeholder={placeholder || ''}
          error={error}
          helperText={helperText}
          animateYearScrolling
          disabled={disabled}
          required={required}
        />
      </MuiThemeProvider>
    );
  }

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      {content}
    </MuiPickersUtilsProvider>
  );
};

Picker.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  action: PropTypes.func,
  format: PropTypes.string,
  variant: PropTypes.string,
  label: PropTypes.string,
  disableUnderline: PropTypes.bool,
  fullWidth: PropTypes.bool,
  dateTime: PropTypes.bool,
  endAdornment: PropTypes.object,
};

export default Picker;

moment.updateLocale('en', {
  monthsShort: [
    'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
    'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC',
  ],
});
